/**
 * 予約に関する定数
 */

/**
 * 日付選択の制限（当日から何日先まで選択可能か）
 */
export const RESERVATION_DATE_LIMIT = {
  SHOWER: 7, // シャワールーム: 7日先まで
  PRIVATE_ROOM: 1, // 防音個室ブース: 翌日まで
} as const;

/**
 * キャンセル締め切り時間（予約開始の何分前までキャンセル可能か）
 */
export const CANCEL_CUTOFF_MINUTES = 0;

/**
 * 営業日基準時間（4:30）
 * バックエンドのArea::BUSINESS_START_HOUR, BUSINESS_START_MINUTEと同期
 * NOTE: 5:00からの予約枠を取れるようにするため、4:30から「当日」扱いにする。
 */
export const BUSINESS_START_HOUR = 4;
export const BUSINESS_START_MINUTE = 30;

/**
 * シャワールームの基準日境界時間
 *
 * この時間以降は基準日を「翌日」に進める。
 * 24の場合は常にカレンダー通りの日付（当日）を基準とする。
 */
export const SHOWER_BASE_DATE_BOUNDARY_HOUR = 24;

/**
 * 防音個室ブースの基準日境界時間
 *
 * この時間以降は基準日を「翌日」に進める。
 * 24の場合は常にカレンダー通りの日付（当日）を基準とする。
 */
export const PRIVATE_ROOM_BASE_DATE_BOUNDARY_HOUR = 24;
